var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullscreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9,14.7a.81.81,0,0,0-.75-.82H27.68a.77.77,0,0,0-.75.82.69.69,0,0,0,.22.53L28.88,17l-4.13,4.13a.4.4,0,0,         0-.15.3.36.36,0,0,0,.15.29L26.18,23a.37.37,0,0,0,.3.15.57.57,0,0,0,.3-.15l4-4.05,1.8,1.8a.81.81,0,0,0,.52.23.78.78,0,0,0,.75-.83ZM24.3,         25.28a.56.56,0,0,0-.15-.31l-1.42-1.34a.39.39,0,0,0-.3-.16.37.37,0,0,0-.3.16l-4.05,4.05-1.8-1.81a.81.81,0,0,0-.53-.22.77.77,0,0,0-.75.82V32a.82.82,         0,0,0,.75.82h5.48A.77.77,0,0,0,22,32a.69.69,0,0,0-.23-.53L20,29.7l4-4.05A.41.41,0,0,0,24.3,25.28Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreen);
export default __webpack_public_path__ + "static/media/fullscreen.366dae7b.svg";
export { ForwardRef as ReactComponent };